import { useNavigate, } from "react-router-dom";
import { AbsoluteCenter, Box, Button, Center, Image, Heading, Stack, } from "@chakra-ui/react";

import { RoutesMap, } from "../../../../routes.tsx";
import exclam from "../../../../assets/exclamation.svg";

export function CameraUnknownErrorView() {
  const navigate = useNavigate();
  return (
    <Box h="100vh" maxW="320px" mx="auto" position="relative">
      <AbsoluteCenter w="100%">
        <Box>
          <Stack spacing={4}>
            <Center>
              <Image src={exclam} />
            </Center>

            <Heading textAlign="center" mb={2}>
              Что-то пошло не так...
            </Heading>

            <Button
              colorScheme="black"
              w="100%"
              onClick={() => {
                window.location.reload();
              }}
            >
              Обновить
            </Button>

            <Button
              onClick={() => {
                navigate(RoutesMap.index,);
              }}
            >
              Вернуться на главную
            </Button>
          </Stack>
        </Box>
      </AbsoluteCenter>
    </Box>
  );
}
